import { const_var, params } from "../../redux/reducers/reducer.js";
import {  changeBuildingData, getSelectedTabstate, isOpenWelcomeModal } from "../../action/index.js";
import * as cuComponent from "../../redux/reducers/building_component/componentReducer.js";
import { buildingStyleChange } from "../../action/building/building_style/buildingStyle.action.js";
import { fetchDefaultBuildingApis, normalizeBuildingMaterials } from "./defaultbuilding.helper.js";
export function getPrepareDefaultBuilding() {
	const_var.showProcessLoaderchkEdit = false;
	const_var.stateManufacturerAcordingAPIDiscount = { commissions: 97, surcharge: [], surchargeArray: 97, discount: 97, mfg_discount: 9, manuName: 97 };

	return async (dispatch) => {
		params.m_s_n = 96;
		params.p_s_n = 1;
		const_var.crmSetting.is_show_background = false;
		try {
			setTimeout(() => {
				document.querySelector(".fullpage-loader")?.classList.remove("spinner-active");
			}, 2000);
			const { default_manufacturer_id: manufacturerId, default_building_id: buildingId, default_price_book_id: priceBookId } = const_var || {};
			const apiData = await fetchDefaultBuildingApis({
				manufacturerId,
				buildingId,
				priceBookId
			});

			const { newBuildingData, newBuildingColor, newBuildingMaterial } = apiData;
			const_var.newMicroserviceApiData = apiData;
			const_var.isForStandardBuilding = false;

			cuComponent.removeAlltheComponent();

			dispatch({
				type: "DISABLE_DOOR_WINDOW_EDIT_ICONS"
			});
			const normalizedMaterials = normalizeBuildingMaterials(newBuildingMaterial?.data);
			const response = {
				newBuildingData: newBuildingData?.data,
				newBuildingColor: newBuildingColor?.data,
				newBuildingMaterial: normalizedMaterials
			};
			if (const_var?.is_intel_edit) {
				const_var.default_building_data = newBuildingData?.data?.default_building;
			}
			dispatch(changeBuildingData(response, newBuildingData?.data, newBuildingColor?.data, normalizedMaterials));

			const_var.showProcessLoaderchkEdit = false;

			dispatch(getSelectedTabstate("buildingtypetab"));
			dispatch(buildingStyleChange(1, []));
			dispatch(isOpenWelcomeModal(true, ""));
			setTimeout(() => {
				const checkaddmodalclass = document.querySelector(".welcomeparent");
				if (checkaddmodalclass != undefined) {
					document.querySelector(".welcomeparent").classList.add("showwelcomeparent");
				}
			}, 500);
			const_var.showReportLoading = false;
			const_var.isGlobalZipUpdate = false;
		} catch (error) {
			console.log("Default Building Error:", error);
		}
	};
}
